import { fontWeights } from '@opallabs/pulsar'

const headerWrapper = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  padding: '14px 25px 0 16px',
}

const flexRow = {
  display: 'flex',
  flexDirection: 'row',
}

const flexColumn = {
  display: 'flex',
  flexDirection: 'column',
}

const header = {
  paddingLeft: '9px',
  alignItems: 'center',
  ...flexRow,
}

const accountName = {
  fontWeight: fontWeights.bolder,
  lineHeight: '16px',
}

const contentWrapper = {
  padding: '6px 11px',
}

const previewWrapper = {
  paddingBottom: '12px',
}

const styles = {
  headerWrapper,
  flexColumn,
  flexRow,
  header,
  accountName,
  contentWrapper,
  previewWrapper,
}

export { styles }
